import {keys} from 'ts-transformer-keys';

type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;

export type LandingPageData = {
    key : string;
    pageHtml? : string;
    pageCss? : string;
    pageDarkCss? : string;
    path? : string;
};
export const requiredLandingPageDataProps = keys<RequiredOf<LandingPageData>>();
export const landingPageDataProps = keys<LandingPageData>();

export type LandingPage = LandingPageData & {
    application : string;
    panelConfig? : number;
    user? : string;
};
export const requiredLandingPageProps = keys<RequiredOf<LandingPage>>();
export const landingPageProps = keys<LandingPage>();
